export default __webpack_public_path__ + "static/media/ic-assignment.f1bf169e.svg";